import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/home.vue'

const routes = [
    {
        path: '/',
        redirect: '/home'
    }, {
        path: '/home',
        name: 'home',
        component: Home
    }, {
        path: '/about',
        name: 'About',
        component: () => import('../views/about.vue')
    }, {
        path: '/product',
        name: 'Product',
        component: () => import('../views/product.vue')
    }, {
        path: '/news',
        name: 'News',
        component: () => import('../views/news.vue')
    }, {
        path: '/news-detail',
        name: 'NewsDetail',
        component: () => import('../views/news-detail.vue')
    }, {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/contact.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
